import { Formik } from 'formik';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

// Images
import banner from '../../../assets/img/illustration.svg';
import TextInput from '../../components/UI/TextInput';

// Services
import { useNavigate } from 'react-router-dom';
import { login } from '../../redux/user/UserActions';
import LoginSchema from '../../validationSchema/login/LoginSchema';

const LoginForm = (props) => (
  <Formik
    initialValues={{ email: '', password: '' }}
    onSubmit={(values) => {
      props.onSubmit(values);
    }}
    validationSchema={LoginSchema}
  >
    {(renderProps) => {
      const { values, touched, errors, handleChange, handleBlur, handleSubmit } = renderProps;
      return (
        <form onSubmit={handleSubmit} className="mt-4">
          <TextInput
            id="email"
            type="email"
            size="mb-4"
            label=""
            placeholder="Email Address"
            className="border-0 shadow form-control-lg"
            error={touched.email && errors.email}
            value={values.email}
            onChange={handleChange}
            onBlur={handleBlur}
          />

          <TextInput
            id="password"
            type="password"
            size="mb-4"
            label=""
            placeholder="Password"
            className="border-0 shadow form-control-lg"
            error={touched.password && errors.password}
            value={values.password}
            onChange={handleChange}
            onBlur={handleBlur}
          />

          <button type="submit" className="btn btn-primary shadow px-5">
            Log in
          </button>
        </form>
      );
    }}
  </Formik>
);

const Login = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { isLoggedIn } = useSelector((state) => state.user);

  const handleLoginSubmit = (formData) => {
    dispatch(login(formData));
  };

  if (isLoggedIn) {
    navigate('/admin');
  }

  return (
    <div className="page-holder d-flex align-items-center">
      <div className="container">
        <div className="row align-items-center py-5">
          <div className="col-5 col-lg-7 mx-auto mb-5 mb-lg-0">
            <div className="pr-lg-5">
              <img src={banner} alt="banner" className="img-fluid" />
            </div>
          </div>
          <div className="col-lg-5 px-lg-4">
            <h1 className="text-base text-primary text-uppercase mb-4">Elite Nannies</h1>
            <h2 className="mb-4">Welcome back!</h2>
            <LoginForm onSubmit={handleLoginSubmit} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
